import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon, FileTextIcon, GlobeIcon, RefreshCwIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
const badges = [{
  Icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  Icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  Icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  Icon: CreditCardIcon,
  label: 'Tarjeta · Transferencia · PayPal'
}, {
  Icon: FileTextIcon,
  label: '100% PDF'
}, {
  Icon: GlobeIcon,
  label: 'Todo Latinoamérica'
}];
export function FinalCta() {
  return <section className="bg-cream px-4 py-16" data-id="element-73">
      <div className="mx-auto max-w-md text-center" data-id="element-74">
        <p className="text-xs font-bold uppercase tracking-widest text-magenta" data-id="element-75">
          ⏰ Último llamado
        </p>
        <div className="mt-4" data-id="element-76">
          <Countdown data-id="element-77" />
        </div>

        <div className="mt-8 rounded-3xl border border-navy/10 bg-white p-6 shadow-soft" data-id="element-78">
          <h3 className="font-display text-xl font-black text-navy" data-id="element-79">
            📘 Método Domingo Libre
          </h3>
          <div className="mt-3" data-id="element-80">
            <span className="font-display text-lg font-bold text-navy/40 line-through" data-id="element-81">
              $97 USD
            </span>
            <div className="mt-1 font-display text-5xl font-black text-magenta" data-id="element-82">
              $12.99 <span className="text-2xl" data-id="element-83">USD</span>
            </div>
            <p className="mx-auto mt-3 inline-flex items-center justify-center gap-1.5 rounded-full bg-teal/10 px-3 py-1.5 text-xs font-bold text-teal" data-id="element-84">
              <RefreshCwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-85" />
              Cambio de moneda automático según tu país.
            </p>
          </div>
          <div className="mt-6" data-id="element-86">
            <CtaButton data-id="element-87" />
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-2.5 text-left" data-id="element-88">
          {badges.map(b => <div key={b.label} className="flex items-center gap-2 rounded-xl bg-white px-3 py-2.5 text-xs font-semibold text-navy/75 shadow-card" data-id="element-89">
              <b.Icon className="h-4 w-4 shrink-0 text-brandpurple" data-id="element-90" />
              <span data-id="element-91">{b.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}